import { Button, Dropdown, Menu, message, Switch, Tooltip, Modal } from "antd";
import ol from "openlayers";
import React from "react";
import {
  iconGeometry,
  QHPK_Polygon,
  QHPK_RanhGioi,
  Google_Layer_Ve_Tinh,
  Google_Layer_Ban_Do,
  iconStyle,
} from "../../../components/ListLayer";
import { AxiosGetSecretApi } from "../../../utils/fetchApi/index";
import Note from "../../TTQH/MapPopup/Note";
import "../MapQuyHoach/map-quy-hoach.scss";
import StaticClass from "../../../utils/staticClass";
import proj4 from "proj4";
proj4.defs(
  "EPSG:6959",
  "+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs"
);
class MapQuyHoach extends React.PureComponent {
  constructor(props) {
    super(props);
    this.map = {};
    this._layers = [];
    this._imgLayer = null;

    this.state = {
      checkedVeTinh: false,
      checkedBanDo: true,

      checkedBanDoGiay: false,
    };

    this._vectorLayer = null;
    this._iconGeometry = iconGeometry;
    this._vectorLayer_MB = null;
    this.BaseLayer = {
      Google_Layer_Ve_Tinh: Google_Layer_Ve_Tinh,
      Google_Layer_Ban_Do: Google_Layer_Ban_Do,
      QHPK_Polygon: QHPK_Polygon,
      QHPK_RanhGioi: QHPK_RanhGioi,
    };
  }

  async componentDidMount() {
    window.onbeforeunload = null;
    this.initMap();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isShowMenu !== this.props.isShowMenu) {
      if (this.map) {
        setTimeout(() => {
          this.map.updateSize();
        }, 1);
      }
    }
    if (prevProps.resetButton !== this.props.resetButton) {
      this.setState({isShowButtonMap: false})
    }
  }

  async initMap() {
    let iconFeature = new ol.Feature({
      geometry: this._iconGeometry,
      name: "Null Island",
      population: 4000,
      rainfall: 500,
    });

    iconFeature.setStyle(iconStyle);

    let vectorSource = new ol.source.Vector({
      features: [iconFeature],
    });

    let vectorLayer = new ol.layer.Vector({
      source: vectorSource,
    });
    vectorLayer.setZIndex(99);

    this.BaseLayer.vectorLayer = vectorLayer

    this._layers.push(this.BaseLayer.Google_Layer_Ban_Do);
    this._layers.push(this.BaseLayer.Google_Layer_Ve_Tinh);
    this._layers.push(this.BaseLayer.QHPK_Polygon);
    this._layers.push(this.BaseLayer.QHPK_RanhGioi);
    this._layers.push(this.BaseLayer.vectorLayer)

    this.BaseLayer.QHPK_RanhGioi.setVisible(false);
    this.BaseLayer.QHPK_Polygon.setVisible(true);
    this.BaseLayer.Google_Layer_Ban_Do.setVisible(true);
    this.BaseLayer.vectorLayer.setVisible(false)
    //end draw icon

    let container = document.getElementById("popup");
    let closer = document.getElementById("popup-closer");

    this._overlayPopup = new ol.Overlay({
      element: container,
      autoPan: true,
      autoPanAnimation: {
        duration: 250,
      },
    });
    let seft = this;
    closer.onclick = function () {
      seft._overlayPopup.setPosition(undefined);
      closer.blur();
      return false;
    };

    this.map = new ol.Map({
      layers: [...this._layers],
      loadTilesWhileInteracting: true,
      target: "map",
      view: new ol.View({
        code: "EPSG:10775",
        center: [12045324.924720876, 1806357.9277613866],
        zoom: 14,
        minZoom: 6,
        maxZoom: 20,
      }),
      overlays: [this._overlayPopup],
      controls: ol.control.defaults({
        attribution: false,
        zoom: true,
      }),
    });
    // het ------------------------------------------------------------------------------------------------------------------

    this.map.on("singleclick", (evt) => {
      // this.setLocation(evt.coordinate);
      let view = this.map.getView();
      let viewResolution = view.getResolution();

      let source = undefined;
      let sourceLoaiDat = undefined;

      source = this.BaseLayer.QHPK_RanhGioi.getSource();
      if (!this.state.checkedBanDoGiay) {
        sourceLoaiDat = this.BaseLayer.QHPK_Polygon.getSource();
      }

      if (source) {
        let url = source.getGetFeatureInfoUrl(
          evt.coordinate,
          viewResolution,
          view.getProjection(),
          {
            INFO_FORMAT: "application/geojson",
            FEATURE_COUNT: "50",
          }
        );
        this.searchDuAnByClick(url, evt);
      }

      if (sourceLoaiDat && !this.state.checkedBanDoGiay) {
        let url = sourceLoaiDat.getGetFeatureInfoUrl(
          evt.coordinate,
          viewResolution,
          view.getProjection(),
          {
            INFO_FORMAT: "application/geojson",
            FEATURE_COUNT: "50",
          }
        );
        this.getLoaiDat(url);
        this._coordinateOverlay = evt.coordinate;
      }
    });

    setTimeout(() => {
      this.map.updateSize();
    }, 1);
  }

  drawPolygon = (data, hideMarker) => {
    let geom = undefined;
    if (data && data._geom) {
      geom = JSON.parse(data._geom);
    }

    let feature;
    if (geom.type === "MultiPolygon") {
      // MultiPolygon
      let convert = geom.coordinates.map((arrCD) => {
        return [
          arrCD[0].map((e) => {
            let arrLocation;
            arrLocation = proj4("EPSG:6959").inverse(e);
            arrLocation = ol.proj.transform(
              arrLocation,
              "EPSG:4326",
              "EPSG:3857"
            );
            return arrLocation;
          }),
        ];
      });
      feature = new ol.Feature({
        geometry: new ol.geom.MultiPolygon(convert),
      });
    } else {
      let convert = geom.coordinates[0].map((e) => {
        let arrLocation;
        arrLocation = proj4("EPSG:6959").inverse(e);
        arrLocation = ol.proj.transform(arrLocation, "EPSG:4326", "EPSG:3857");
        return arrLocation;
      });
      feature = new ol.Feature({
        geometry: new ol.geom.Polygon([convert]),
      });
    }
    // feature.getGeometry().transform("EPSG:4326", "EPSG:3857");

    let vectorSource = new ol.source.Vector({
      features: [feature],
    });

    let aa = feature.getGeometry().getExtent();
    let oo = ol.extent.getCenter(aa);
    if(!hideMarker)this._iconGeometry.setCoordinates(oo);
    this.map.getView().setCenter(oo);

    this.map.getView().fit(aa, this.map.getSize(), { duration: 2000 });

    if (this.map.getView().getZoom() > 21) {
      this.map.getView().setZoom(21);
    }

    if (this._vectorLayer_MB) {
      this._vectorLayer_MB.setSource(
        new ol.source.Vector({
          features: [feature],
        })
      );
    } else {
      this._vectorLayer_MB = new ol.layer.Vector({
        source: vectorSource,
        style: new ol.style.Style({
          stroke: new ol.style.Stroke({ color: "#OOFFFF", width: 6 }),
          // fill: new ol.style.Fill({ color: "#4286f430" }),
        }),
      });
      this.map.getLayers().push(this._vectorLayer_MB);
    }
  };

  setLocation = (oo, zoom) => {
    this.map.getView().setCenter(oo);
    if (zoom) {
      this.map.getView().setZoom(zoom);
    }
    this._iconGeometry.setCoordinates(oo);
  };

  async showOverLayeInfo(data) {
    let _contentPopup = document.getElementById("popup-content");
    let dataDuAn = undefined;
    let res = await AxiosGetSecretApi(
      `/api/qh-phan-khu/getById-mb?ID=${data.OBJECTID}`
    );
    if (res && res.length !== 0) {
      dataDuAn = res[0];
      if (res && res.length !== 0) {
        dataDuAn = res[0];
        this.drawPolygon(res[0]);
      }
    }
    _contentPopup.innerHTML =
      '<div class="header-title-popup">Thông tin chi tiết mặt bằng quy hoạch</div>' +
      "</hr>" +
      `<div style="display: flex;">
              <div class="text-title-popup">Tên phân khu:</div>
              <div class="text-content-popup">${
                dataDuAn && dataDuAn.TenPhanKhu ? dataDuAn.TenPhanKhu : "-"
              }</div>
          </div> 
    
          <div style="display: flex;">
              <div class="text-title-popup">Tên loại đất:</div>
              <div class="text-content-popup">${
                dataDuAn && dataDuAn.TenloaiPolygon
                  ? dataDuAn.TenloaiPolygon
                  : "-"
              }</div>
          </div> 
    
          <div style="display: flex;">
              <div class="text-title-popup">Diện tích (ha):</div>
              <div class="text-content-popup">${
                dataDuAn && dataDuAn.DienTichFormat ? StaticClass.formatPrice(dataDuAn.DienTichFormat) : "-"
              }</div>
          </div> 
    
          <div style="display: flex;">
              <div class="text-title-popup">Mô tả:</div>
              <div class="text-content-popup">${
                dataDuAn && dataDuAn.MoTa ? dataDuAn.MoTa : "-"
              }</div>
          </div> `;
    this._overlayPopup.setPosition(this._coordinateOverlay);
  }

  //--------------------ban do giay--------------------//
  async searchDuAnByClick(url, evt) {
    let res = await AxiosGetSecretApi(url);
    if (
      res &&
      res.features &&
      Array.isArray(res.features) &&
      res.features.length !== 0 &&
      res.features[0].properties &&
      res.features[0].properties.OBJECTID
    ) {
      if (this.OBJECTID !== res.features[0].properties.OBJECTID) {
        this.OBJECTID = res.features[0].properties.OBJECTID;
        this.props.searchDataTable(this.OBJECTID);
        this.setLocation(evt.coordinate);

        // get ban do giay
        if (this.state.checkedBanDoGiay) {
          if (
            res.features[0].properties.MaPhanKhu &&
            res.features[0].properties.MaPhanKhu !== "null" &&
            res.features[0].properties.MaPhanKhu !== "Null"
          ) {
            this.urlImg = `/api/ban-do-giay/tim-theo-ma-pk?code=${res.features[0].properties.MaPhanKhu}`;
            this.getImageBanDoGiay(this.urlImg);
          }
        }
      }
    } else {
      message.error("Chưa có thông tin dự án (Dữ liệu đang cập nhật)");
    }
  }

  async getImageBanDoGiay(url) {
    let res = await AxiosGetSecretApi(url);
    if (res && Array.isArray(res) && res.length > 0 && res[0].URL) {
      this.setState({
        isShowButtonMap: true,
      });
      let extent = [res[0].Left, res[0].Bottom, res[0].Right, res[0].Top];
      extent = ol.proj.transformExtent(
        extent,
        ol.proj.get("EPSG:4326"),
        ol.proj.get("EPSG:3857")
      );

      this.map.getView().setCenter(ol.extent.getCenter(extent));
      this.map.getView().fit(extent, this.map.getSize(), { duration: 2000 });

      this._imgOvelayerLink = res[0].URL + "/" + res[0].Name;
      if (this._imgLayer) {
        this._imgLayer.setSource(
          new ol.source.ImageStatic({
            url: res[0].URL + "/" + res[0].Name,
            imageExtent: extent,
          })
        );
      } else {
        this._imgLayer = new ol.layer.Image({
          source: new ol.source.ImageStatic({
            url: res[0].URL + "/" + res[0].Name,
            imageExtent: extent,
          }),
        });
        this.map.getLayers().push(this._imgLayer);
      }
    } else {
      if (this._imgLayer) {
        this._imgLayer.setSource(undefined);
      }
      this.setState({
        isShowButtonMap: false,
      });
      message.error("Chưa có thông tin bản đồ giấy (Dữ liệu đang cập nhật)");
    }
  }

  onShowFullImg = async () => {
    let res = await AxiosGetSecretApi(`${this.urlImg}a`);
    if (res && res.length > 0) {
      this.srcImg = `${res[0].URL}/${res[0].Name}`;
      this.setState({
        isShowModal: true,
      });
    } else {
      message.error("Chưa có thông tin (dữ liệu đang cập nhật)");
    }
  };

  onDownloadImgOverlay = () => {
    let self = this;
    window.open(self._imgOvelayerLink, "_blank");
  };
  //--------------------==========--------------------//

  // get data loai dat

  async getLoaiDat(url) {
    let res = await AxiosGetSecretApi(url);
    if (
      res &&
      res.features &&
      Array.isArray(res.features) &&
      res.features.length !== 0 &&
      res.features[0].properties &&
      res.features[0].properties
    ) {
      this.setState({
        dataLoaiDat: res.features[0].properties,
      });

      this.showOverLayeInfo(res.features[0].properties);
    }
  }

  //get data - -   - -  - -  - -  - -  - -  - -  - -  - -  - -  - -  - -  - -  - -  - -  - -  - -  - -  - -

  drawRing = (data) => {
    //draw line
    this.map.getView().setZoom(14);
    this.map.getView().setCenter([12045324.924720876, 1806357.9277613866]);
    if (this._vectorLayer) {
      this._vectorLayer.getSource().clear();
    }

    // this._iconGeometry.setCoordinates([12045324.924720876, 1806357.9277613866]);

    if (data && data.length !== 0) {
      let listPoint = [];
      data.forEach((e) => {
        let x = new ol.Feature({
          geometry: new ol.geom.LineString(e),
        });
        listPoint.push(x);
      });

      let vectorSource = new ol.source.Vector({
        features: listPoint,
      });

      let aa = listPoint[0].getGeometry().getExtent();
      let oo = ol.extent.getCenter(aa);
      // this._iconGeometry.setCoordinates(oo);
      this.map.getView().setCenter(oo);

      this.map.getView().fit(aa, this.map.getSize(), { duration: 2000 });

      if (this.map.getView().getZoom() > 21) {
        this.map.getView().setZoom(21);
      }

      if (this._vectorLayer) {
        this._vectorLayer.setSource(
          new ol.source.Vector({
            features: listPoint,
          })
        );
      } else {
        this._vectorLayer = new ol.layer.Vector({
          source: vectorSource,
          style: new ol.style.Style({
            fill: new ol.style.Fill({
              color: "rgba(255, 255, 255, 0.2)",
            }),
            stroke: new ol.style.Stroke({
              color: "#00FFFF",
              width: 6,
            }),
            image: new ol.style.Circle({
              radius: 7,
              fill: new ol.style.Fill({
                color: "#ffcc33",
              }),
            }),
          }),
        });
        this.map.getLayers().push(this._vectorLayer);
      }
    }
  };

  drawRingQuyHoach = (data) => {
    //draw line
    this.map.getView().setZoom(14);
    this.map.getView().setCenter([12045324.924720876, 1806357.9277613866]);
    if (this._vectorLayerQuyHoach) {
      this._vectorLayerQuyHoach.getSource().clear();
    }

    // this._iconGeometry.setCoordinates([12045324.924720876, 1806357.9277613866]);

    if (data && data.length !== 0) {
      let listPoint = [];
      data.forEach((e) => {
        let x = new ol.Feature({
          geometry: new ol.geom.LineString(e),
        });
        listPoint.push(x);
      });

      let vectorSource = new ol.source.Vector({
        features: listPoint,
      });

      let aa = listPoint[0].getGeometry().getExtent();
      let oo = ol.extent.getCenter(aa);
      // this._iconGeometry.setCoordinates(oo);
      this.map.getView().setCenter(oo);

      this.map.getView().fit(aa, this.map.getSize(), { duration: 2000 });

      if (this.map.getView().getZoom() > 21) {
        this.map.getView().setZoom(21);
      }

      if (this._vectorLayerQuyHoach) {
        this._vectorLayerQuyHoach.setSource(
          new ol.source.Vector({
            features: listPoint,
          })
        );
      } else {
        this._vectorLayerQuyHoach = new ol.layer.Vector({
          source: vectorSource,
          style: new ol.style.Style({
            fill: new ol.style.Fill({
              color: "rgba(255, 255, 255, 0.2)",
            }),
            stroke: new ol.style.Stroke({
              color: "#00FFFF",
              width: 6,
            }),
            image: new ol.style.Circle({
              radius: 7,
              fill: new ol.style.Fill({
                color: "#ffcc33",
              }),
            }),
          }),
        });
        this.map.getLayers().push(this._vectorLayerQuyHoach);
      }
    }
  };

  handleCloseClick = (e) => {
    this.BaseLayer.vectorLayer.setVisible(false)
    this.map.getView().setZoom(14);
    this.map.getView().setCenter([12045324.924720876, 1806357.9277613866]);
    if (this._vectorLayer) {
      this._vectorLayer.getSource().clear();
    }

    if (this._vectorLayerQuyHoach) {
      this._vectorLayerQuyHoach.getSource().clear();
    }

    if (this._imgLayer) {
      this._imgLayer.setSource(undefined);
    }

    this._iconGeometry.setCoordinates([12045324.924720876, 1806357.9277613866]);
    this._overlayPopup.setPosition(undefined);
    // closer.blur();
  };

  //--------------------change ban do--------------------//
  onChangeBanDoSo(value, type) {
    switch (type) {
      case "BanDo":
        this.BaseLayer.Google_Layer_Ve_Tinh.setVisible(false);
        this.BaseLayer.Google_Layer_Ban_Do.setVisible(value);
        this.setState({
          checkedBanDo: value,
          checkedVeTinh: false,
        });
        break;

      case "VeTinh":
        this.BaseLayer.Google_Layer_Ve_Tinh.setVisible(value);
        this.BaseLayer.Google_Layer_Ban_Do.setVisible(false);
        this.setState({
          checkedBanDo: false,
          checkedVeTinh: value,
        });
        break;
    }
  }

  onChangeBanDoGiay(value) {
    this.BaseLayer.QHPK_Polygon.setVisible(!value);
    this.BaseLayer.QHPK_RanhGioi.setVisible(value);
    this.setState({ checkedBanDoGiay: value });
    this.OBJECTID = undefined;

    if (value) {
      this._overlayPopup.setPosition(undefined);
    } else {
      if (this._imgLayer) {
        this._imgLayer.setSource(undefined);
      }
    }
    if (this._vectorLayer) {
      this._vectorLayer.getSource().clear();
    }    
    if (this._vectorLayer_MB) {
      this._vectorLayer_MB.setSource(undefined);
    }

    if (this._vectorLayerQuyHoach) {
      this._vectorLayerQuyHoach.getSource().clear();
    }
  }
  //--------------------==========--------------------//

  getMyLocation() {
    const location = window.navigator && window.navigator.geolocation;
    if (location) {
      location.getCurrentPosition(
        (position) => {
          let data = {
            toaDoX: position.coords.longitude,
            toaDoY: position.coords.latitude,
            myLocation: true,
          };

          // this.jumpToLocation(data);
          let oo = ol.proj.transform(
            [parseFloat(data.toaDoX), parseFloat(data.toaDoY)],
            "EPSG:4326",
            "EPSG:3857"
          );
          this.setLocation(oo, 19);
          this.BaseLayer.vectorLayer.setVisible(true);
        },
        (error) => {
          message.error("Không thể xác định vị trí");
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: Infinity,
        }
      );
    }
  }

  render() {
    return (
      <div id="do-an-quy-hoach" className="map-quy-hoach">
        <div className="map-bound " id="map-bound">
          <div id="map" className="map quy-hoach-ol-map" ref="map ">
            <button
              className="button-location btn-geo-on-map map-control-button"
              onClick={() => {
                this.getMyLocation();
              }}
            >
              <i className="fas fa-location-arrow"></i>
            </button>

            <div className="map-button-quy-hoach">
              <Dropdown
                overlay={
                  <Menu className="menu-layer">
                    <Menu.Item key="VeTinh">
                      <div className="fl-bw">
                        <div className="text">Vệ tinh</div>
                        <Switch
                          checked={this.state.checkedVeTinh}
                          onChange={(value) => {
                            this.onChangeBanDoSo(value, "VeTinh");
                          }}
                        ></Switch>
                      </div>
                    </Menu.Item>
                    <Menu.Divider />

                    <Menu.Item key="BanDo">
                      <div className="fl-bw">
                        <div className="text">Đường phố</div>
                        <Switch
                          checked={this.state.checkedBanDo}
                          onChange={(value) => {
                            this.onChangeBanDoSo(value, "BanDo");
                          }}
                        ></Switch>
                      </div>
                    </Menu.Item>

                    <Menu.Divider />
                    <Menu.Item>
                      <div className="fl-bw">
                        <div className="text">Bản đồ giấy</div>
                        <Switch
                          checked={this.state.checkedBanDoGiay}
                          onChange={(value) => {
                            this.onChangeBanDoGiay(value);
                          }}
                        ></Switch>
                      </div>
                    </Menu.Item>
                  </Menu>
                }
                trigger={["click"]}
              >
                <Tooltip title="Chuyển đổi nền" placement="bottomRight">
                  <button className="map-control-button-search button-left">
                    <i className="fas fa-map"></i>
                  </button>
                </Tooltip>
              </Dropdown>

              <Tooltip title="Chú giải" placement="bottom">
                <button className="map-control-button-search button-right">
                  <i
                    className="fas fa-list-ul"
                    onClick={() => {
                      this.setState({
                        isShowNotePopup: !this.state.isShowNotePopup,
                      });
                    }}
                  ></i>
                </button>
              </Tooltip>
            </div>

            {this.state.isShowNotePopup ? (
              <Note
                type="tab2"
                close={() => {
                  this.setState({ isShowNotePopup: false });
                }}
              ></Note>
            ) : null}

            {this.state.isShowButtonMap && this.state.checkedBanDoGiay ? (
              <div className="div-show-full">
                <Button
                  className="btn-show-full-img"
                  onClick={this.onShowFullImg}
                  type="primary"
                >
                  Xem đầy đủ
                </Button>

                <Button
                  className="btn-show-full-img"
                  onClick={this.onDownloadImgOverlay}
                  type="primary"
                >
                  Tải về
                </Button>
              </div>
            ) : null}

            {this.state.isShowModal && (
              <Modal
                visible={this.state.isShowModal}
                onCancel={() => {
                  this.setState({ isShowModal: false });
                }}
                footer={null}
                width={window.screen.width - 300}
                closable={false}
              >
                <img
                  // src={`https://sxd.sgmcvietnam.vn${this.srcImg}`}
                  src={`http://10.17.20.52${this.srcImg}`}
                  style={{ width: "100%", height: "auto" }}
                  alt=" "
                ></img>
              </Modal>
            )}
          </div>
        </div>

        <div id="popup" className="ol-popup">
          <a href="#" id="popup-closer" className="ol-popup-closer" />
          <div id="popup-content" />
        </div>
      </div>
    );
  }
}

export default MapQuyHoach;
